import { colour } from '../styles/GlobalStyles';

// Available colors for status badges
export const COLOR_PALETTE = {
    yellow: { bg: 'bg-colour-yellow-01', dot: colour.yellow02, dotBg: 'bg-colour-yellow-02' },
    jade:   { bg: 'bg-colour-jade-01',   dot: colour.jade02,   dotBg: 'bg-colour-jade-02'   },
    orange: { bg: 'bg-colour-orange-01', dot: colour.orange02, dotBg: 'bg-colour-orange-02' },
    purple: { bg: 'bg-colour-purple-01', dot: colour.purple02, dotBg: 'bg-colour-purple-02' },
    red:    { bg: 'bg-colour-red-01',    dot: colour.red02,    dotBg: 'bg-colour-red-02'    },
    gray:   { bg: 'bg-colour-gray-02',   dot: colour.gray04,   dotBg: 'bg-colour-gray-04'   },
    blue:   { bg: 'bg-colour-blue-01',   dot: colour.blue02,   dotBg: 'bg-colour-blue-02'   },
    pink:   { bg: 'bg-colour-pink-01',   dot: colour.pink02,   dotBg: 'bg-colour-pink-02'   },
};

export const COLOR_NAMES = Object.keys(COLOR_PALETTE);

// Default statuses — used when company has no custom config
export const DEFAULT_DEAL_STATUSES = [
    { key: 'watch_list',                  label: 'Watch List',                    color: 'yellow' },
    { key: 'qualified_find_buyer',        label: 'Qualified – Find Buyer',        color: 'jade'   },
    { key: 'qualified_mgmt_review',       label: 'Qualified – Mgmt Review',       color: 'orange' },
    { key: 'qualified_internal_purchase', label: 'Qualified – Internal Purchase', color: 'purple' },
    { key: 'unqualified_failed_uw',       label: 'Unqualified – Failed UW',       color: 'red'    },
    { key: 'unqualified_unavailable',     label: 'Unqualified – Unavailable',     color: 'gray'   },
];

/**
 * Get deal status config and options from company data.
 * Falls back to defaults when no custom statuses are configured.
 *
 * @param {object|null} companyData
 * @returns {{ config: Object, options: Array }}
 */
export function getDealStatuses(companyData) {
    const statuses = (Array.isArray(companyData?.dealStatuses) && companyData.dealStatuses.length > 0)
        ? companyData.dealStatuses
        : DEFAULT_DEAL_STATUSES;

    const config = {};
    const options = [{ label: 'No status', value: null }];

    for (const s of statuses) {
        const palette = COLOR_PALETTE[s.color] || COLOR_PALETTE.gray;
        config[s.key] = { label: s.label, bg: palette.bg, dot: palette.dot, notifyEmails: s.notifyEmails || [] };
        options.push({ label: s.label, value: s.key });
    }

    return { config, options };
}

/**
 * Generate a unique key for a new custom status.
 */
export function generateStatusKey() {
    return `custom_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;
}
